import React, { memo, useState } from 'react';
import Link from 'next/link';
import Box from '@mui/material/Box';
import ListItemText from '@mui/material/ListItemText';
import Popover from '@mui/material/Popover';

import { Container, StyledList, StyledListItem } from '../../styles';
import { NavbarButtonMenu } from '../navbar-button-menu';

interface NavbarPopoverProps {
  title: string;
  items: {
    label: string;
    link?: string;
    subItems?: {
      label: string;
      link: string;
    }[];
  }[];
}

export const NavbarPopover = memo<NavbarPopoverProps>(({ title, items }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <Container displayPrint="none">
      <NavbarButtonMenu
        id={id}
        isOpen={open}
        onClick={handleClick}
        title={title}
      />

      <Popover
        id={id}
        anchorEl={anchorEl}
        onClose={handleClose}
        open={open}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        sx={{
          '& .MuiPopover-paper': {
            backgroundColor: `transparent`,
          },
        }}
      >
        <StyledList>
          {items.map(({ label, link, subItems }) =>
            subItems ? (
              <StyledListItem key={`navbar-${label}`} color={'white'}>
                <Box
                  sx={(theme) => ({
                    display: `flex`,
                    alignItems: `center`,
                    gap: `12px`,
                    fontWeight: 600,
                    padding: `14px 10px 0 28px`,
                    color: theme.palette.secondary.main,
                  })}
                >
                  {label}
                </Box>
                {subItems.map(({ label, link }) => (
                  <a
                    key={`submenu-${label}`}
                    href={link}
                    target="_blank"
                    rel="noopener"
                  >
                    <ListItemText sx={{ pl: 2, pr: 1 }}>{label}</ListItemText>
                  </a>
                ))}
              </StyledListItem>
            ) : (
              <StyledListItem key={link} color={'white'}>
                <Link
                  href={link}
                  prefetch={false}
                  target="_blank"
                  rel="noopener"
                >
                  <ListItemText>{label}</ListItemText>
                </Link>
              </StyledListItem>
            )
          )}
        </StyledList>
      </Popover>
    </Container>
  );
});
